import { type ISale } from "@/interfaces/api/sale.interface"
import { SaleItem } from "@/models/sale-item.model"
import type { Purchase } from "@/models/purchase.model"
import { allArrayElementsEqual } from "@/helper/collection-helper"
import { ModelFactory } from "@/factories/model-factory"
import { Transaction } from "@/models/transaction.model"

export class Sale extends Transaction implements ISale {
  public static className = "Sale" // Used for socket communication.
  public static verboseName = "Verkoop"

  saleItem: SaleItem

  productionStatement?: string
  productionStatementCreationJob?: string

  productionStatementReference?: string
  surchargeModifier: string | undefined

  constructor(sale: ISale, managed = false) {
    super(sale, managed)

    this.id = sale.id
    this.saleItem = ModelFactory.childModel(SaleItem, sale.saleItem, managed)

    this.productionStatement = sale.productionStatement
    this.productionStatementCreationJob = sale.productionStatementCreationJob

    this.surchargeModifier = sale.surchargeModifier
    this.productionStatementReference = sale.productionStatementReference
  }

  /** Locked while linked to a production statement or reserved by a creation job generating one. */
  public isLocked(): boolean {
    return Boolean(this.productionStatement || this.productionStatementCreationJob)
  }

  public matchesPurchase(purchase: Purchase) {
    return (
      purchase.purchaseItem?.saleItem?.id === this.saleItem?.id && // Same product
      ((!purchase.quantity && !this.quantity) || // Both have no quantity (e.g. when creating new transactions)
        Number(purchase.quantity) === Number(this.quantity)) && // Same quantity
      allArrayElementsEqual(
        purchase.fileBucket.fileRelations,
        this.fileBucket.fileRelations,
        "file.id"
      ) // Same related files
    )
  }

  public getItem() {
    return this.saleItem
  }

  public getSurchargePercentage(): number {
    if (this.surchargeModifier) {
      return super.getSurchargePercentage() * parseFloat(this.surchargeModifier)
    }
    return super.getSurchargePercentage()
  }
}
